import { faker } from "@faker-js/faker/locale/fr"
import { SourceName } from "../../../../types"
import type { ApiFinancialDataBiosimilarsSummary } from "../../../performance/biosimilars"

const fakeDate = () => faker.date.recent({ days: 365 }).toISOString().split("T")[0]
const maybe = <T>(val: T) => faker.helpers.maybe(() => val, { probability: 0.8 })
const rate = () => faker.number.float({ min: 0, max: 100, fractionDigits: 2 })

export const biosimilarsSummaryMock = (): ApiFinancialDataBiosimilarsSummary => ({
  pharmacyId: faker.number.int({ min: 0, max: 9_999_999_999 }),
  sources: [SourceName.SANTESTAT],
  periodStartDate: fakeDate(),
  periodEndDate: fakeDate(),
  substitutionRate: {
    mainStat: maybe(rate()) ?? null,
  },
  target: maybe(rate()) ?? null,
})
